import React from "react"
import PropTypes from "prop-types"

import {ErrorMessage } from "../styled"

const allowedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "(", ")", "-", " ", "Backspace", "Delete", "Tab"]
const ctrlC = event => event.ctrlKey && event.key === "c"
const ctrlV = event => event.ctrlKey && event.key === "v"
const ctrlZ = event => event.ctrlKey && event.key === "z"

const onKeyDown = (event) => {
  if (!allowedKeys.includes(event.key) && !ctrlC(event) && !ctrlV(event) && !ctrlZ(event)) {
    event.stopPropagation()
    event.preventDefault()
  }
}

export const NumberInput = ({
  field,
  form: {touched, errors},
  ...props
}) => {
  return (
    <>
      <input
        type={props.type} {...field} {...props}
        className="form-control"
        placeholder={props.placeholder}
        disabled={props.disabled}
        maxLength={props.maxLength}
        onKeyDown={onKeyDown}
        onInput={(event) => event.target.value = event.target.value.toString().slice(0, props.maxLength)} />
      {touched[field.name] && errors[field.name] && <ErrorMessage>{errors[field.name]}</ErrorMessage>}
    </>
  )
}

NumberInput.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number
}
